import EndUserLicenseAgreement from "../components/EulaComponent";

const EulaPage = () => {
  return <EndUserLicenseAgreement />;
};

export default EulaPage;
